import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { ARTICLE_FEATURE, ArticleState, StateWithArticle } from '../article-state';

export const getArticleState: MemoizedSelector<StateWithArticle, ArticleState> =
  createFeatureSelector<ArticleState>(ARTICLE_FEATURE);
